// 交货方式枚举
export enum DeliveryMethod {
  PICKUP_AT_STORE = 1,
  HOME_DELIVERY = 2,
  EXPRESS_DELIVERY = 3
}

// 交货方式映射函数
export function deliveryMethodOptionsMapper(t:(key: string)=>string) {
  return [
    { value: DeliveryMethod.PICKUP_AT_STORE, label: t('PlaceOrderChild.PickupAtStore') },
    { value: DeliveryMethod.HOME_DELIVERY, label: t('PlaceOrderChild.ProvideHomeDeliveryService') },
    { value: DeliveryMethod.EXPRESS_DELIVERY, label: t('PlaceOrderChild.ExpressDelivery') }
  ];
}

// 普通商品订单状态枚举
export enum OrderStatus {
  STATUS_PENDING_PAYMENT = 1,
  STATUS_CANCELED = 2,
  STATUS_PAID = 3,
  STATUS_SHIPPED = 4,
  STATUS_COMPLETED = 5,
}

// 普通商品订单状态映射函数
export function orderStatusOptionsMapper() {
  return [
    { value: OrderStatus.STATUS_PENDING_PAYMENT, label: "PendingPayment" },
    { value: OrderStatus.STATUS_CANCELED, label: "Cancelled" },
    { value: OrderStatus.STATUS_PAID, label: "Paid" },
    // { value: OrderStatus.STATUS_SHIPPED, label: "Shipped" },
    { value: OrderStatus.STATUS_COMPLETED, label: "Completed" },
  ];
}


// 普通商品退款状态
export enum OrderRefundStatus {
  REFUNDED = 1,//已退款
  NOT_REFUNDED = 0,//未退款
 
}

// 普通商品订单状态映射函数
export function orderRefundStatusOptionsMapper() {
  return [
    { value: OrderRefundStatus.REFUNDED, label: "Refunded" },
    { value: OrderRefundStatus.NOT_REFUNDED, label: "Not Refunded" },
    
  ];
}


// STATUS_PENDING_PAYMENT = 0
//     STATUS_CANCELED = -1
//     STATUS_PAID = 1
//     STATUS_COMPLETED = 2
//     STATUS_CHOICES = (
//         (STATUS_PENDING_PAYMENT, '待支付'),
//         (STATUS_CANCELED, '已取消/退款'),
//         (STATUS_PAID, '已支付/待使用'),
//         (STATUS_COMPLETED, '已完结/已服务')
//     )

// 普通服务订单状态枚举
export enum ServiceOrderStatus {
  STATUS_PENDING_PAYMENT = 0,
  STATUS_CANCELED = -1,
  STATUS_PAID = 1,
  STATUS_COMPLETED = 2,

}

// 普通服务订单状态映射函数
export function serviceOrderStatusOptionsMapper() {
  return [
    { value: ServiceOrderStatus.STATUS_PENDING_PAYMENT, label: "PendingPayment" },
    { value: ServiceOrderStatus.STATUS_CANCELED, label: "Cancelled" },
    { value: ServiceOrderStatus.STATUS_PAID, label: "Paid" },
    { value: ServiceOrderStatus.STATUS_COMPLETED, label: "Completed" },
  ];
}






// # 订单状态枚举
//     STATUS_PENDING_PAYMENT = 1
//     STATUS_CANCELED = 2
//     STATUS_PAID = 3
//     STATUS_SHIPPED = 4
//     STATUS_COMPLETED = 5
//     STATUS_CHOICES = (
//         (STATUS_PENDING_PAYMENT, '待支付'),
//         (STATUS_CANCELED, '已取消'),
//         (STATUS_PAID, '已支付'),
//         (STATUS_SHIPPED, '已上车'),
//         (STATUS_COMPLETED, '已到达目的地'),
//     )

// 订单状态枚举
export enum CarpoolOrderStatus {
  STATUS_PENDING_PAYMENT = 1,
  STATUS_CANCELED = 2,
  STATUS_PAID = 3,
  STATUS_SHIPPED = 4,
  STATUS_COMPLETED = 5,
}

// 拼车订单状态映射函数 Carpool Service
export function carpoolOrderStatusOptionsMapper() {
  return [
    { value: CarpoolOrderStatus.STATUS_SHIPPED, label: "Draft" },
    { value: CarpoolOrderStatus.STATUS_PENDING_PAYMENT, label: "PendingPayment" },//1
    { value: CarpoolOrderStatus.STATUS_PAID, label: "Cancelled" },//3
    { value: CarpoolOrderStatus.STATUS_CANCELED, label: "Ongoing" },//2
    { value: CarpoolOrderStatus.STATUS_COMPLETED, label: "Processed" },//5
    
  ];
}

// 售后状态枚举
export enum AfterSaleStatus {
  NO_AFTER_SALE = 0,
  APPLYING = 1,
  WAITING_SHIP = 2,
  WAITING_RECEIVE = 3,
  REFUND_PROCESSING = 4,
  REFUNDED = 5,
  REJECTED = 6,
  CANCELLED = 7
}

// 售后状态映射函数
export function afterSaleStatusOptionsMapper() {
  return [
    { value: AfterSaleStatus.NO_AFTER_SALE, label: "No After Sale" },
    { value: AfterSaleStatus.APPLYING, label: "Applying" },
    { value: AfterSaleStatus.WAITING_SHIP, label: "Waiting for Shipment" },
    { value: AfterSaleStatus.WAITING_RECEIVE, label: "Waiting for Receipt" },
    { value: AfterSaleStatus.REFUND_PROCESSING, label: "Refund Processing" },
    { value: AfterSaleStatus.REFUNDED, label: "Refunded" },
    { value: AfterSaleStatus.REJECTED, label: "Rejected" },
    { value: AfterSaleStatus.CANCELLED, label: "Cancelled" }
  ];
}


// Emergency Service 紧急服务订单状态枚举
export enum EmergencyServiceOrderStatus {
  STATUS_DRAFT = 0,
  STATUS_PENDING = 1,
  STATUS_ONGOING = 2,
  STATUS_CANCELED = 3,
  STATUS_PROCESSED = 4,
}
// Emergency Service 紧急服务订单状态映射函数
export function emergencyServiceOrderStatusOptionsMapper() {
  return [
    { value: EmergencyServiceOrderStatus.STATUS_DRAFT, label: "Draft" },
    { value: EmergencyServiceOrderStatus.STATUS_PENDING, label: "Pending" },
    { value: EmergencyServiceOrderStatus.STATUS_ONGOING, label: "Ongoing" },
    { value: EmergencyServiceOrderStatus.STATUS_CANCELED, label: "Canceled" },
    { value: EmergencyServiceOrderStatus.STATUS_PROCESSED, label: "Processed" }
  ];
}
export function serviceCarpoolOrderStatus() {
  return [
    { value: EmergencyServiceOrderStatus.STATUS_DRAFT, label: "Pending" },
    { value: EmergencyServiceOrderStatus.STATUS_PENDING, label: "canceled" },//1
    { value: EmergencyServiceOrderStatus.STATUS_ONGOING, label: "Ongoing" },//3
    { value: EmergencyServiceOrderStatus.STATUS_CANCELED, label: "Processed" },//2
    { value: EmergencyServiceOrderStatus.STATUS_CANCELED, label: "Lost" },//5
    
  ];
}
// Store orders 产品订单状态枚举
export enum StoreOrderProductStatus {
  STATUS_PENDING_PAYMENT = 1,
  STATUS_PAID = 2,
  STATUS_PROCESSING = 3,
  STATUS_SHIPPED = 4,
  STATUS_COMPLETED = 5,
  STATUS_CANCELED = 6,
  STATUS_AWAITING_REFUND = 7,
  STATUS_REFUNDED = 8,
}

// Store orders 产品订单状态映射函数
export function storeOrderProductStatusOptionsMapper() {
  return [
    { value: StoreOrderProductStatus.STATUS_PENDING_PAYMENT, label: "Pending Payment" },
    { value: StoreOrderProductStatus.STATUS_PAID, label: "Paid" },
    { value: StoreOrderProductStatus.STATUS_PROCESSING, label: "Processing" },
    { value: StoreOrderProductStatus.STATUS_SHIPPED, label: "Shipped" },
    { value: StoreOrderProductStatus.STATUS_COMPLETED, label: "Completed" },
    { value: StoreOrderProductStatus.STATUS_CANCELED, label: "Canceled" },
    { value: StoreOrderProductStatus.STATUS_AWAITING_REFUND, label: "Awaiting Refund" },
    { value: StoreOrderProductStatus.STATUS_REFUNDED, label: "Refunded" },
  ];
}